<!--
    Styles
-->

<style>

    .ui-options {
        overflow-y: auto;
    }

</style>



<!--
    Template
-->

<template>
    <div class="ui-options dropdown">
        <a class="option u-row" v-for="(option, index) in iterable" :key="index" @click="update(option)">{{ option }}</a>
        <slot />
    </div>
</template>



<!--
    Scripts
-->

<script>

    export default {

        props: [
            'options'
        ],

        computed: {

            iterable () {
                return Array.isArray(this.options) ?
                    this.options : this.options.keys();
            }

        },

        methods: {

            update (option) {
                this.$emit('update', option);
                this.$parent.hide();
            }

        }

    }

</script>

